export default "__VITE_ASSET__2E02GIPE__"